import { lazy } from "react";

export const Conversations = lazy(
  () => import(/* webpackChunkName: 'conversation' */ "pages/conversations"),
);

export const Page404 = lazy(
  () => import(/* webpackChunkName: '404' */ "pages/404"),
);

export const Login = lazy(
  () => import(/* webpackChunkName: 'login' */ "pages/user/login"),
);

export const Forgot = lazy(
  () => import(/* webpackChunkName: 'forgot' */ "pages/user/forgot"),
);

export const ResetPassword = lazy(
  () =>
    import(/* webpackChunkName: 'resetPassword' */ "pages/user/resetPassword"),
);

export const Invite = lazy(
  () => import(/* webpackChunkName: 'invite' */ "pages/user/invite"),
);

export const SelectCompany = lazy(
  () =>
    import(/* webpackChunkName: 'selectCompany' */ "pages/user/selectCompany"),
);

export const BillingPaymentSuccess = lazy(
  () =>
    import(
      /* webpackChunkName: 'billingPaymentSuccess' */ "pages/user/billing/success"
    ),
);

export const ListCompanies = lazy(
  () => import(/* webpackChunkName: 'listCompanies' */ "pages/companies"),
);

export const Profile = lazy(
  () => import(/* webpackChunkName: 'profile' */ "pages/settings/profile"),
);

export const Roles = lazy(
  () => import(/* webpackChunkName: 'roles' */ "pages/settings/roles"),
);

export const AddRole = lazy(
  () =>
    import(/* webpackChunkName: 'addRole' */ "pages/settings/roles/AddRole"),
);

export const EditRole = lazy(
  () =>
    import(/* webpackChunkName: 'editRole' */ "pages/settings/roles/EditRole"),
);

export const Users = lazy(
  () => import(/* webpackChunkName: 'users' */ "pages/settings/users"),
);

export const Channels = lazy(
  () => import(/* webpackChunkName: 'channels' */ "pages/settings/channels"),
);

export const InhouseChannelDetail = lazy(
  () =>
    import(
      /* webpackChunkName: 'inhousechanneldetail' */ "pages/settings/channels/inhouse/Detail"
    ),
);

export const Apps = lazy(
  () => import(/* webpackChunkName: 'apps' */ "pages/settings/apps"),
);

export const CreateApp = lazy(
  () =>
    import(/* webpackChunkName: 'createapp' */ "pages/settings/apps/Create"),
);

export const DetailApp = lazy(
  () =>
    import(/* webpackChunkName: 'detailapp' */ "pages/settings/apps/Detail"),
);

export const Settings = lazy(
  () => import(/* webpackChunkName: 'settings' */ "pages/settings"),
);

export const Company = lazy(
  () =>
    import(/* webpackChunkName: 'settingsCompany' */ "pages/settings/company"),
);

export const Billings = lazy(
  () =>
    import(/* webpackChunkName: 'settingsBilling' */ "pages/settings/billings"),
);

export const BillingUpgrade = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsBillingUpgrade' */ "pages/settings/billings/upgrade"
    ),
);

export const BillingAddon = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsBillingAddon' */ "pages/settings/billings/addon"
    ),
);

export const BusinessFlow = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsBusinessFlow' */ "pages/settings/businessflow"
    ),
);

export const Templates = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsTemplates' */ "pages/settings/templates"
    ),
);

export const MainPage = lazy(
  () => import(/* webpackChunkName: 'mainPage' */ "pages/MainPage"),
);

export const ConversationIndex = lazy(
  () =>
    import(
      /* webpackChunkName: 'mainPage' */ "pages/conversations/ConversationIndex"
    ),
);

export const ContactPage = lazy(
  () => import(/* webpackChunkName: 'contactPage' */ "pages/contact"),
);

export const DetailContactPage = lazy(
  () =>
    import(/* webpackChunkName: 'detailContactPage' */ "pages/contact/Detail"),
);

export const EditContactPage = lazy(
  () => import(/* webpackChunkName: 'editContactPage' */ "pages/contact/Edit"),
);

export const ImportContactPage = lazy(
  () =>
    import(/* webpackChunkName: 'importContactPage' */ "pages/contact/Import"),
);

export const Tags = lazy(
  () => import(/* webpackChunkName: 'Tags' */ "pages/settings/tags"),
);

export const Categories = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsCategories' */ "pages/settings/categories"
    ),
);

export const BlastPage = lazy(
  () => import(/* webpackChunkName: 'BlastPage' */ "pages/blast"),
);

export const CreateBlastPage = lazy(
  () =>
    import(/* webpackChunkName: 'CreateBlastPage'*/ "pages/blast/CreateBlast"),
);

export const DetailBlastPage = lazy(
  () => import(/* webpackChunkName: 'DetailBlastPage*/ "pages/blast/Detail"),
);

export const Divisions = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsCategories' */ "pages/settings/division"
    ),
);

export const LeadAndTaskManagement = lazy(
  () =>
    import(
      /* webpackChunkName: 'leadAndTaskManagement' */ "pages/taskManagement"
    ),
);

export const Reports = lazy(
  () => import(/* webpackChunkName: 'reports' */ "pages/reports"),
);

export const ChatLinesCount = lazy(
  () =>
    import(
      /* webpackChunkName: 'chatLinesCount' */ "pages/reports/chatLinesCount"
    ),
);

export const OnlineDuration = lazy(
  () =>
    import(
      /* webpackChunkName: 'onlineDuration' */ "pages/reports/onlineDuration"
    ),
);

export const TeamResponseTime = lazy(
  () =>
    import(
      /* webpackChunkName: 'responseTime' */ "pages/reports/teamResponseTime"
    ),
);

export const IndividualResponseTime = lazy(
  () =>
    import(
      /* webpackChunkName: 'responseTime' */ "pages/reports/individualResponseTime"
    ),
);

export const AutoTransferConversation = lazy(
  () =>
    import(
      /* webpackChunkName: 'autoTransfer' */ "pages/reports/autoTransferConversation"
    ),
);

export const DetailAutoTransferConversation = lazy(
  () =>
    import(
      /* webpackChunkName: 'detailAutoTransferConversation' */ "pages/reports/autoTransferConversation/Detail"
    ),
);

export const DetailResponseTime = lazy(
  () =>
    import(
      /* webpackChunkName: 'detailResponseTime' */ "pages/reports/individualResponseTime/Detail"
    ),
);

export const Help = lazy(
  () => import(/* webpackChunkName: 'faqs' */ "pages/help"),
);

export const HelpDetail = lazy(
  () => import(/* webpackChunkName: 'faqDetail' */ "pages/help/Detail"),
);

export const FaqUser = lazy(
  () => import(/* webpackChunkName: 'faqUser' */ "pages/faqUser"),
);

export const MeetingManagement = lazy(
  () =>
    import(
      /* webpackChunkName: 'meetingManagement' */ "pages/settings/meetingManagement"
    ),
);

export const MeetingSchedule = lazy(
  () =>
    import(/* webpackChunkName: 'meetingSchedule' */ "pages/meetingSchedule"),
);

export const Audit = lazy(
  () => import(/* webpackChunkName: 'audit' */ "pages/settings/audit"),
);

export const StatisticUserRating = lazy(
  () =>
    import(
      /* webpackChunkName: 'statisticUserRating' */ "pages/reports/statisticUserRating"
    ),
);

export const ListOfUserRating = lazy(
  () =>
    import(
      /* webpackChunkName: 'listOfUserRating' */ "pages/reports/listOfUserRating"
    ),
);

export const SettingsQualityAssurance = lazy(
  () =>
    import(
      /* webpackChunkName: 'settingsQualityAssurance' */ "pages/settings/qualityAssurance"
    ),
);

export const QualityAssurance = lazy(
  () =>
    import(/* webpackChunkName: 'qualityAssurance' */ "pages/qualityAssurance"),
);

export const DataQualityAssuranceReportsPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'dataQualityAssuranceReports' */ "pages/reports/dataQualityAssurance"
    ),
);

export const StatisticQualityAssuranceReportsPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'statisticQualityAssuranceReports' */ "pages/reports/statisticQualityAssurance"
    ),
);

export const AgentNumCharStatistics = lazy(
  () =>
    import(
      /* webpackChunkName: 'agentNumCharStatistics' */ "pages/reports/agentNumCharStatistics"
    ),
);

export const DailyTeamChatStatistics = lazy(
  () =>
    import(
      /* webpackChunkName: 'dailyTeamChatStatistics' */ "pages/reports/dailyTeamChatStatistics"
    ),
);

export const VolumeIncoming = lazy(
  () =>
    import(
      /* webpackChunkName: 'volumeIncoming' */ "pages/reports/volumeIncoming"
    ),
);

export const WebhookPage = lazy(
  () => import(/* webpackChunkName: 'webhook' */ "pages/settings/webhook"),
);

export const TicketingPage = lazy(
  () => import(/* webpackChunkName: 'ticketing' */ "pages/ticketing"),
);

export const CreateTicketPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'createTicket' */ "pages/ticketing/CreateTicket"
    ),
);

export const DetailTicketPage = lazy(
  () => import(/* webpackChunkName: 'detailTicket' */ "pages/ticketing/Detail"),
);

export const InboxTicketingPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'inboxTicketing' */ "pages/settings/inboxTicketing"
    ),
);

// [crm-iso] START — hidden feature (lihat CrmIsoSetting/TEARDOWN.md)
export const CrmIsoSettingPage = lazy(
  () =>
    import(
      /* webpackChunkName: 'crmIsoSetting' */ "pages/settings/crmIsoSetting"
    ),
);
// [crm-iso] END
export const ChatBot = lazy(
  () => import(/* webpackChunkName: 'chatbot' */ "pages/settings/chatbot"),
);

export const ChatBotFlow = lazy(
  () =>
    import(
      /* webpackChunkName: 'chatbot-flow' */ "pages/settings/chatbot/flow"
    ),
);
